import PropTypes from 'prop-types'
import { useMemo } from 'react'
import styled from 'styled-components/macro'

import { grayishMapStyles } from 'core/ui/components/map/Map.styles'

import { MapContainer } from 'legacy/components/MapV2/MapContainer'

function mapLoadStops(loadStops) {
  return loadStops.map(someStop => ({
    ...someStop,
    id: someStop.id || someStop.window_start,
    longitude: `${someStop.longitude}`,
    latitude: `${someStop.latitude}`,
  }))
}

function parseLoad(load) {
  return load && load.stops
    ? {
        ...load,
        stops: mapLoadStops(load.stops),
      }
    : {
        stops: [],
      }
}

const StopsMapContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`

const StopsMapLoading = styled.div`
  display: flex;
`

const StyledMapContainer = styled(MapContainer)`
  border: none;
  cursor: default;
`

const mapContainerStyle = {
  height: '100%',
  width: '100%',
}

function StopsMap({ load, isLoading }) {
  const parsedLoad = useMemo(() => parseLoad(load), [load])

  if (isLoading) return <StopsMapLoading />

  return (
    <StopsMapContainer>
      <StyledMapContainer
        enableZoomControl={false}
        forceDefaultMarkerIcon
        mapStyles={grayishMapStyles}
        mapContainerStyle={mapContainerStyle}
        primaryRouteColor="#14d64d"
        primaryRouteStrokeWeight={3.5}
        showAlternativeRoutes={false}
        showMarkerTooltip={false}
        shipment={parsedLoad}
      />
    </StopsMapContainer>
  )
}

StopsMap.propTypes = {
  load: PropTypes.shape({}),
  isLoading: PropTypes.bool,
}

StopsMap.defaultProps = {
  load: undefined,
  isLoading: false,
}

export { StopsMap }
